<template>
  <AppDialog
    v-if="config.visible"
    v-model="config.visible"
    title="Skill授权"
    width="900px"
    height="520px"
    :btn-footer="false"
  >
    <div class="container">
      <div class="toolbar">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="onAdd"
        >添加授权码</el-button>
      </div>
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        size="small"
        style="width: 100%"
      >
        <el-table-column label="授权码" min-width="200">
          <template slot-scope="{ row }">
            <span class="auth-code-cell">
              <span class="auth-code-text">{{ maskAuthCode(row.authCode) }}</span>
              <el-tooltip content="复制授权码" placement="top">
                <i
                  class="el-icon-document-copy copy-icon"
                  @click="onCopy(row)"
                />
              </el-tooltip>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="名称" min-width="140" show-overflow-tooltip />
        <el-table-column label="有效期" min-width="260">
          <template slot-scope="{ row }">
            <span>{{ formatValidRange(row) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="备注" min-width="160" show-overflow-tooltip />
        <el-table-column label="操作" width="80" fixed="right">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              size="small"
              class="danger-text"
              @click="onDelete(row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrap">
        <el-pagination
          :current-page="query.pageIndex"
          :page-size="query.pageSize"
          :total="total"
          :page-sizes="[10, 20, 50]"
          layout="total, sizes, prev, pager, next"
          background
          small
          @size-change="onSizeChange"
          @current-change="onPageChange"
        />
      </div>
    </div>

    <!-- 添加授权码弹窗 -->
    <AppDialog
      v-if="addConfig.visible"
      v-model="addConfig.visible"
      title="添加授权码"
      width="480px"
      height="auto"
      :loading="addLoading"
      @success="onAddConfirm"
      @close="onAddClose"
    >
      <div class="add-form-wrap">
        <el-form
          ref="addForm"
          :model="addForm"
          :rules="addRules"
          label-width="90px"
          size="small"
        >
          <el-form-item label="名称" prop="name">
            <el-input
              v-model="addForm.name"
              placeholder="请输入名称"
              maxlength="30"
              show-word-limit
            />
          </el-form-item>
          <el-form-item label="有效期" prop="validRange">
            <el-date-picker
              v-model="addForm.validRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="生效时间"
              end-placeholder="失效时间（可空表示永久）"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 100%;"
            />
          </el-form-item>
          <el-form-item label="备注" prop="description">
            <el-input
              v-model="addForm.description"
              type="textarea"
              :rows="3"
              placeholder="请输入备注"
              maxlength="100"
              show-word-limit
            />
          </el-form-item>
        </el-form>
      </div>
    </AppDialog>
  </AppDialog>
</template>

<script>
import AppDialog from '@/components/AppDialog'
import { copy } from '@/utils'
import {
  getAgentAuthCodePage,
  addAgentAuthCode,
  deleteAgentAuthCode
} from '@/api/user/agentAuthCode.js'

export default {
  name: 'HokClawAuthDialog',
  components: {
    AppDialog
  },
  props: {
    config: {
      type: Object,
      default: () => ({
        visible: false
      })
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      query: {
        pageIndex: 1,
        pageSize: 10
      },
      addConfig: {
        visible: false
      },
      addLoading: false,
      addForm: {
        name: '',
        validRange: [],
        description: ''
      },
      addRules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    'config.visible'(val) {
      if (val) {
        this.query.pageIndex = 1
        this.fetchList()
      }
    }
  },
  methods: {
    // 授权码脱敏：展示前4位和后4位
    maskAuthCode(code) {
      if (!code) return '--'
      if (code.length <= 8) return '****'
      return `${code.slice(0, 4)}****${code.slice(-4)}`
    },
    formatValidRange(row) {
      const start = row.effectTime || '--'
      const end = row.expireTime || '永久'
      return `${start} ~ ${end}`
    },
    async fetchList() {
      this.loading = true
      try {
        const res = await getAgentAuthCodePage(this.query)
        const data = res.data || {}
        this.tableData = data.items || []
        this.total = data.total || 0
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    onPageChange(page) {
      this.query.pageIndex = page
      this.fetchList()
    },
    onSizeChange(size) {
      this.query.pageSize = size
      this.query.pageIndex = 1
      this.fetchList()
    },
    onAdd() {
      this.addForm = { name: '', validRange: [], description: '' }
      this.addConfig.visible = true
      this.$nextTick(() => {
        this.$refs.addForm && this.$refs.addForm.clearValidate()
      })
    },
    onAddClose() {
      this.addConfig.visible = false
    },
    onAddConfirm() {
      this.$refs.addForm.validate(async valid => {
        if (!valid) return
        this.addLoading = true
        try {
          const { name, description, validRange } = this.addForm
          const payload = {
            name,
            description,
            effectTime: validRange && validRange[0] ? validRange[0] : null,
            expireTime: validRange && validRange[1] ? validRange[1] : null
          }
          await addAgentAuthCode(payload)
          this.$message.success('添加成功')
          this.addConfig.visible = false
          this.query.pageIndex = 1
          this.fetchList()
        } catch (e) {
          console.error(e)
        } finally {
          this.addLoading = false
        }
      })
    },
    async onDelete(row) {
      try {
        await this.$confirm('确定要删除该授权码吗？删除后不可恢复。', '提示', {
          type: 'warning'
        })
      } catch (e) {
        return
      }
      try {
        await deleteAgentAuthCode(row.id)
        this.$message.success('删除成功')
        // 如果当前页删完了，回退一页
        if (this.tableData.length === 1 && this.query.pageIndex > 1) {
          this.query.pageIndex -= 1
        }
        this.fetchList()
      } catch (e) {
        console.error(e)
      }
    },
    onCopy(row) {
      if (!row.authCode) {
        this.$message.warning('授权码为空')
        return
      }
      copy(row.authCode)
      this.$message.success('复制成功')
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  padding: 16px 20px;
  box-sizing: border-box;
  height: 100%;
  overflow: auto;
  .toolbar {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 12px;
  }
  .pagination-wrap {
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;
  }
  .danger-text {
    color: #f53f3f;
  }
  .auth-code-cell {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    .auth-code-text {
      font-family: Consolas, Menlo, monospace;
      letter-spacing: 1px;
    }
    .copy-icon {
      color: #0c6fff;
      cursor: pointer;
      font-size: 14px;
      &:hover {
        opacity: 0.75;
      }
    }
  }
}
.add-form-wrap {
  padding: 20px 20px 0;
  box-sizing: border-box;
}
</style>
